module.exports = __webpack_public_path__ + "img/FreedomInAfrica.33e4aa42.gif";